<template>
	<div class="zjxNotice">
		<div class="zxj_notice">
			<div class="zxj_notice__title">
				<p>{{detail.newsTitle}}</p>
			</div>
			<div class="zxj_notice__other">
				<!-- <span>文件文号：建协函（2022）59号</span> -->
				<span>点击量：{{detail.readTotal}}</span>
				<span>发布时间：{{detail.publishTimeWeb}}</span>
				<!-- <span>分享到：+*x=</span> -->
			</div>
			<div class="zxj_notice__detail" v-html="detail.newsContent">
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getAtricDetail
	} from '../../../api/moudles/home.js'
	export default {
		data() {
			return {
				detail: {},
				newId: ''
			}
		},
		watch: {
			'$route': function() {
				if (this.newId != this.$route.params.id) {
					this.newId = this.$route.params.id
					this.getAtricDetail(this.$route.params.id)
				}
			}
		},
		created() {
			if (this.$route.params.id) {
				this.newId = this.$route.params.id
				this.getAtricDetail(this.$route.params.id)
			}
		},
		methods: {
			async getAtricDetail(id) {
				await getAtricDetail({
					data: {
						id
					},
					success: res => {
						console.log('res', res.data)
						this.detail = res.data
					}
				})
			}
		}
	}
</script>

<style scoped>
	>>>.zxj_notice__detail>p>img,
	.zxj_notice__detail>img,
	.zxj_notice__detail>span>img{
		max-width: 100% !important;
		height: 100% !important;
	}
	@media screen and (max-width: 750px) {
		.zxj_notice {
			width: 100%;
			min-height: 650px;
			padding-bottom: 60px;
			background-color: #fff;
		}
	}
	@media screen and (min-width: 750px) {
		.zxj_notice {
			width: 1200px;
			min-height: 650px;
			background-color: #fff;
		}
	}
	.zjxNotice {
		min-height: 710px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.zxj_notice__title {
		width: 90%;
		margin-left: 5%;
		min-height: 70px;
		font-size: 24px;
		font-weight: 600;
		text-align: center;
		line-height: 70px;
		border-bottom: 1px solid #f5f5f5;
	}
	
	.zxj_notice__other {
		height: 50px;
		line-height: 50px;
		width: 80%;
		margin-left: 10%;
		display: flex;
		justify-content: space-evenly;
	}
	
	.zxj_notice__other>span {
		font-size: 14px;
		color: #d3d3d3;
	}
	
	.zxj_notice__detail {
		margin: 20px 0;
		width: 90%;
		margin-left: 5%;
	}
</style>
